import { render, staticRenderFns } from "./switcherLiveAdUnitIcon.vue?vue&type=template&id=18722be3&"
import script from "./switcherLiveAdUnitIcon.vue?vue&type=script&lang=js&"
export * from "./switcherLiveAdUnitIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports